export const VENDOR_ID = 124912 // LIVE
export const ENVIROMENT = false; // if true then sandbox else production 
export const PLANID = {
    YEARLY: 902405,
    MONTHLY : 902406
};
